'use client';
import React from 'react';

interface StepperChipsProps {
  steps: string[];
  active: number;
  onChange: (index: number) => void;
  id?: string;
  className?: string;
}

const StepperChips: React.FC<StepperChipsProps> = ({ steps, active, onChange, id, className }) => {
  if (!Array.isArray(steps) || steps.length === 0) return null;

  function onKeyDown(e: React.KeyboardEvent<HTMLElement>) {
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      onChange(Math.min(active + 1, steps.length - 1));
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      onChange(Math.max(active - 1, 0));
    } else if (e.key === 'Home') {
      e.preventDefault();
      onChange(0);
    } else if (e.key === 'End') {
      e.preventDefault();
      onChange(steps.length - 1);
    }
  }

  return (
    <div
      className={['stepper stepper-chips', className].filter(Boolean).join(' ')}
      data-stepper
      id={id}
      tabIndex={0}
      onKeyDown={onKeyDown}
      aria-label='Stepper navigation'
    >
      <ol className='stepper-list' role='list'>
        {steps.map((step, i) => (
          <li
            key={step}
            className={`stepper-step${i === active ? ' is-active' : ''}`}
            data-step={i + 1}
            aria-current={i === active ? 'step' : undefined}
            onClick={() => onChange(i)}
          >
            <span className='dot'>{i + 1}</span>
            <span>{step}</span>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default StepperChips;
